
import mixinFlex from './mixin-flex'

export default {
  name: 'VsStack',
  mixins: [
    mixinFlex
  ],
  props: {
    horizontal: {
      type: [Boolean, Object],
      default: null
    },
    gap: {
      type: [Boolean, String, Number, Object],
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  vessel: {
    default: {
      $attrs: 'all',
      stack: true,
      $direction: 'stackDirection',
      $gap: 'stackGap',
      $horizontal: {
        stackDirection(value) {
          return value == true
            ? 'row'
            : value == false ? 'col' : null
        }
      }
    }
  }
}
